/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Angulars Standard-Auffang beim Bootstrap. `console` ist hier die einzig moegliche
// Ausgabe: schlaegt der Bootstrap fehl, gibt es noch keinen Injector und damit auch
// keinen DebugLogService — und keine Oberflaeche, die eine Meldung zeigen koennte.
// Deshalb hier ausdruecklich erlaubt statt ueber den Dienst geleitet.
// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
